<template>
  <div class="response-container">
    <div class="response-description">
      <img :alt="response.alt" :src="response.img">
      <h1>{{ response.title }}</h1>
      <p>{{ response.description }}</p>
    </div>
    <div>
      <main-button
        v-if="showForgotPassword"
        flat
        color="white"
        @click.prevent="handleForgotPassword"
      >
        zaboravljena lozinka?
      </main-button>
      <main-button class="button-style" color="#333" @click.prevent="$emit('next')">
        {{ response.buttonLabel }}
      </main-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sign-in-response',
  props: {
    response: {
      type: Object,
      default: () => {},
    },
    showForgotPassword: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleForgotPassword() {
      let routeData = this.$router.resolve({ name: this.routes.shared.forgotPassword })
      window.open(routeData.href, '_blank')
    },
  },
}
</script>

<style scoped>
.response-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 2.5rem;
}
.response-description {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
}
.button-style {
  border-radius: 0;
  background: black;
  width: 116px;
}
h1 {
  color: #333;
  text-align: center;
  font-family: Rubik;
  font-size: 32px;
  font-style: normal;
  font-weight: 550;
  line-height: 120%; /* 38.4px */
  letter-spacing: -0.96px;
}
p {
  color: #333;
  text-align: center;
  font-family: Rubik;
  font-size: 20px;
  font-style: normal;
  font-weight: 450;
  line-height: 150%; /* 30px */
  letter-spacing: -0.6px;
}
</style>
